import React, { useEffect } from "react";
import "./App.css";
import Sidebar from "./components/sidebar/Sidebar";
import Home from "./components/home/Home";
import About from "./components/about/About";
import Resume from "./components/resume/Resume";
import Services from "./components/services/Services";
import Skills from "./components/skills/Skills";
import TechStack from "./components/techstack/TechStack";
import Portfolio from "./components/portfolio/Portfolio";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import ScrollToHash from "./components/ScrollToHash";
import Terminal from "./components/terminal/Terminal";
import { Routes, Route, useLocation } from "react-router-dom";
import WorkDetail from "./components/portfolio/WorkDetail";
import AnalyticsDashboard from "./components/analytics/AnalyticsDashboard";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { trackEvent } from "./analytics";

const App = () => {
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 400,
      once: true,
      offset: 50
    });
  }, []);

  useEffect(() => {
    trackEvent({
      eventType: "page_view",
      path: location.pathname,
      pageTitle: document.title
    });
  }, [location.pathname]);

  return (
    <>
      <ScrollToHash />
      <Sidebar />
      <main className="main">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Home />
                <About />
                <Resume />
                <Services />
                <Skills />
                <TechStack />
                <Portfolio />
                <Contact />
                <Footer />
              </>
            }
          />
          <Route path="/work/:id" element={<WorkDetail />} />
          <Route path="/analytics" element={<AnalyticsDashboard />} />
          <Route path="/stats" element={<AnalyticsDashboard />} />
        </Routes>
      </main>
      <Terminal />
    </>
  );
}

export default App;